import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncAdjustIncome = loadable(() => import('./AdjustIncome'), {
  fallback: <Loader />,
});
